import React from 'react';
import { Typography, Link, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import StyledCheckBox from '../atoms/StyledCheckBox';

const CheckBoxTermsOfUse = ({
  color, checked, onChange, ...rest
}) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiSvgIcon-root': {
        color: theme.palette[color].main,
      },
    },
    link: {
      color: theme.palette[color].main,
    },
  }));
  const classes = useStyles();

  return (
    <StyledCheckBox
      onChange={onChange}
      checked={checked}
      color="primary"
      name="termos_aceitos"
      className={classes.root}
      label={(
        <Typography variant="body2">
          {'Li e aceito a '}
          <Link
            className={classes.link}
            target="_blank"

            href="https://conube-pt-prod-nv.s3-us-east-1.amazonaws.com/proposta-conube-servicos-contabil-folha-e-fiscal.pdf"
          >
            Política de Privacidade
          </Link>
          {' e os '}
          <Link
            className={classes.link}
            target="_blank"

            href="https://conube-pt-prod-nv.s3-us-east-1.amazonaws.com/proposta-conube-servicos-contabil-folha-e-fiscal.pdf"
          >
            Termos de uso
          </Link>
          {' da Conube.'}
        </Typography>
      )}
      {...rest}
    />
  );
};

CheckBoxTermsOfUse.propTypes = {
  color: PropTypes.any.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CheckBoxTermsOfUse;
